import '@polymer/polymer/polymer-legacy.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
Polymer({
  _template: html``,

  /*
    fires toast, prompt, cancel-prompt, secondary-prompt, cancel-secondary-prompt zoom-to-active
  */
  is: 'navigate-to-location',

  properties: {
    activeCommand: {
      type: String,
      notify: true
    },
    activeItem: {
      type: String,
      notify: true
    },
    color: {
      type: String,
      value: '#303F9F'
    },
    icon: {
      type: String,
      value: 'maps:navigation'
    },
    latitude: Number,
    longitude: Number
  },

  init: function (button) {
    this.activeCommand = 'select';
    this.fire('prompt', { text: 'Select Destination' });
    this.fire('cancel-secondary-prompt');
  },

  map_pan: function (latitude, longitude, closest) {
    if (closest == null) {
      this.activeItem = '';
    } else if (closest.item[0] != 'c') {
      this.activeItem = closest.item;
    } else {
      this.activeItem = '';
    }
  },

  select: function () {
    let lat = this.latitude;
    let long = this.longitude;
    if (this.activeItem != '') {
      let item = this.domHost.getByKey('', this.activeItem);
      if (item != null) {
        lat = item.latitude;
        long = item.longitude;
      }
    }
    if (lat != null && long != null) {
      let parameters = [];
      if (this.gpsData.latitude && this.gpsData.longitude) {
        parameters.push(`origin=${this.gpsData.latitude},${this.gpsData.longitude}`);
      }
      parameters.push(`destination=${lat},${long}`);
      parameters = parameters.join('&');
      let href = encodeURI(`https://www.google.com/maps/dir/?api=1&${parameters}`);
      window.location.href = href;
    }
  }
});
